module.exports = __webpack_public_path__ + "a7731fd1e6e62e2845e42319615a661a.png";